<div class="contact-admin-modal">
    <button class="close-btn" aria-label="Close" (click)="onClose()">
        <app-icon name="close" colour="black" />
    </button>

    <h2 class="alert-title">Contact admin</h2>

    <div class="image-wrapper">
        <app-icon name="info" size="120px" />
    </div>

    <p class="description">
        If you've spotted an error or have a question regarding your access, you can easily contact your <b>Admin</b>
        for access.
    </p>

    <hr class="divider" />

    <div class="admin-details">
        <p><b>Admin:</b> {{ adminName }}</p>
        <p class="detail-link">Email: <a [href]="'mailto:' + adminEmail">{{ adminEmail }}</a></p>
        <!-- <p class="detail-link">Phone: <a [href]="'tel:' + adminPhone">{{ adminPhone }}</a></p> -->
    </div>

    <button class="primary full understand-btn" (click)="onUnderstand()">I understand</button>
</div>